/*
 * The single-question answer comparison, as it reads inside the catalog dialog.
 * It borrows the matrix vocabulary — value, missing answer, thinness of a mean —
 * so the two screens do not describe the same data in two different ways.
 */
.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
}

.question {
  font-size: var(--size-300);
  font-weight: var(--weight-medium);
}

.body {
  max-width: 60ch;

  font-size: var(--size-200);

  color: var(--text-muted);
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-xs);
}

/* Same pill as the catalog tree and the matrix, for the same three states. */
.badge {
  padding: 0 var(--space-xs);

  font-size: var(--size-100);
  font-weight: 600;

  border: 1px solid currentColor;
  border-radius: var(--radius-pill);
}

.counted {
  opacity: 0.75;
}

.outside {
  color: var(--band-missing);

  border-width: 2px;
}

.unanswered {
  color: var(--text-faint);

  border-style: dashed;
}

.product {
  font-weight: var(--weight-medium);
}

.value {
  font-variant-numeric: tabular-nums;
  font-weight: var(--weight-medium);
}

.text {
  font-size: var(--size-100);

  color: var(--text-muted);
}

.absent {
  color: var(--text-faint);
}

.author {
  font-size: var(--size-100);

  color: var(--text-muted);
}

.summary {
  display: flex;
  align-items: baseline;
  gap: var(--space-s);
}

.mean {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.thinness {
  font-size: var(--size-100);

  color: var(--text-faint);
}

.caveat {
  max-width: 60ch;

  font-size: var(--size-100);

  color: var(--text-faint);
}
